import { createReducer, on } from '@ngrx/store';
import { FapResponse } from '@api/backend';
import { ErrorResponse } from '@core/models';
import { searchActions } from '@app2/store/search/search.actions';

export const searchFeatureKey = 'search';

export interface SearchState {
  isLoading: boolean;
  error: ErrorResponse | undefined
  list: FapResponse[]
  nextPage: number | undefined
  query: string | undefined
  total: number | undefined
}

const initialState: SearchState = {
  isLoading: false,
  error: undefined,
  list: [],
  nextPage: undefined,
  query: undefined,
  total: undefined,
};

export const searchReducer = createReducer(
  initialState,
  on(
    searchActions.loadFaps,
    (state, { defaultList, q }): SearchState => ({
      ...state, isLoading: true, list: defaultList ? [] : state.list, query: q, total: undefined,
    }),
  ),
  on(
    searchActions.loadFapsSuccess,
    (state, { data }): SearchState => ({
      ...state,
      isLoading: false,
      list: [...state.list, ...data.faps],
      nextPage: data.next_page,
      total: data.total_pages,
    }),
  ),
  on(
    searchActions.loadFapsFailure,
    (state, { error }): SearchState => ({
      ...state,  isLoading: false, error,
    }),
  ),

);

